type AscendMetrics = {
  nibt: number;
  nibth: number;
  eng: number;
  tbwl: number;
};

export const AscendProgramLevels = [
  { title: 'CE', level: 3, minNibth: 10, minNibt: 120, minEng: 0.8, minTbwl: 12 },
  { title: 'AC', level: 2, minNibth: 10, minNibt: 60, minEng: 0.8, minTbwl: 10 },
  { title: 'CC', level: 1, minNibth: 10, minNibt: 5, minEng: 0, minTbwl: 0 },
  { title: 'None', level: 0, minNibth: 0, minNibt: 0, minEng: 0, minTbwl: 0 },
];

export function getAscendMetrics(metrics: AscendMetrics, countryCode: string | null) {
  let partnerLevel =
    AscendProgramLevels.find(
      (level) =>
        metrics.nibt >= level.minNibt &&
        metrics.nibth >= level.minNibth &&
        metrics.eng >= level.minEng &&
        metrics.tbwl >= level.minTbwl
    ) || AscendProgramLevels.find((level) => level.level === 0)!;

  if (countryCode === 'FR' && metrics.nibth > 10 && partnerLevel.level === 0) {
    partnerLevel = AscendProgramLevels.find((level) => level.level === 1)!;
  }

  const level = partnerLevel!.level;
  const levelTitle = partnerLevel!.title;
  const levelScore = Math.pow(10, level * 2) + metrics.nibt;

  return { level, levelTitle, levelScore };
}

export function promoteClinic(metrics: AscendMetrics, targetLevel: number) {
  const targetLevelData = AscendProgramLevels.find((level) => level.level === targetLevel);

  if (!targetLevelData) {
    throw new Error(`Invalid target level: ${targetLevel}`);
  }

  return {
    nibt: Math.max(metrics.nibt, targetLevelData.minNibt),
    nibth: Math.max(metrics.nibth, targetLevelData.minNibth),
    eng: Math.max(metrics.eng, targetLevelData.minEng),
    tbwl: Math.max(metrics.tbwl, targetLevelData.minTbwl),
  };
}
